import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 dash-canvas">
      <div className="relative z-10 w-full max-w-md text-center">
        <div className="mb-8">
          <h1 className="select-none text-9xl font-bold text-hairline/80">404</h1>
        </div>

        <div className="dash-card-surface mb-8 p-8 shadow-saas">
          <div className="mb-6">
            <h2 className="type-auth-title mb-2 text-ink-graphite">{t('notFound.title')}</h2>
            <p className="text-steel">
              {t('notFound.description')}
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/"
              className="block w-full rounded-input bg-cta-gradient py-3 px-6 text-center font-semibold text-white opacity-[0.98] transition-opacity duration-200 hover:opacity-100"
            >
              {t('notFound.backHome')}
            </Link>

            <button
              type="button"
              onClick={() => window.history.back()}
              className="w-full rounded-input border border-hairline bg-card-surface py-3 px-6 font-semibold text-ink-graphite transition-colors duration-200 hover:bg-sky-wash"
            >
              {t('notFound.backPrev')}
            </button>
          </div>
        </div>

        <div className="text-sm text-steel">
          <p>{t('notFound.support')}</p>
        </div>
      </div>

      <div className="pointer-events-none absolute left-10 top-10 h-20 w-20 rounded-full bg-sky-wash opacity-40" aria-hidden />
      <div className="pointer-events-none absolute bottom-10 right-10 h-32 w-32 rounded-full bg-sky-wash/60 opacity-50" aria-hidden />
      <div className="pointer-events-none absolute left-1/4 top-1/2 h-16 w-16 -translate-y-1/2 rounded-full bg-sky-wash/40 opacity-40" aria-hidden />
    </div>
  );
};

export default NotFound;
